module.exports = __webpack_public_path__ + "media/images/icons/arrow-right-7eb0fc815f6de5cca00e650826c649de.svg";